import { render, staticRenderFns } from "./CDRepositoryDescription.vue?vue&type=template&id=57a00ed7&scoped=true"
import script from "./CDRepositoryDescription.vue?vue&type=script&lang=ts"
export * from "./CDRepositoryDescription.vue?vue&type=script&lang=ts"
import style0 from "./CDRepositoryDescription.vue?vue&type=style&index=0&id=57a00ed7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a00ed7",
  null
  
)

export default component.exports